import Status from 'clarks/components/ivu-table/status' 

let forms = {
   addUser: {
      icon: 'fa fa-user',
      title: 'Add User',
      subtitle: 'Provide User Details',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12', model: 'name',
            validation: 'required|min:3|max:50', label: 'Name',
         },
         {
            type: 'mobile', form_type: 'text', class: 'col-12', model: 'phone',
            validation: 'required|phone', label: 'Phone Number'
         },
         {
            type: 'text', form_type: 'email', class: 'col-12 col-lg-6', model: 'email',
            validation: 'required|min:3|max:150|email', label: 'Email',
         },
         {
            type: 'select', class: 'col-12 col-lg-6', model: 'role', filterable: true, clearable: true,
            multiple: false,options: [], validation: 'required', label: 'Role'
         },
      ]
   },
   editUser: {
      icon: 'fa fa-user',
      title: 'Edit User',
      subtitle: 'Provide User Details',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12', model: 'names',
            validation: 'required|min:3|max:50', label: 'Name',
         },
         {
            type: 'mobile', form_type: 'text', class: 'col-12', model: 'phone_number',
            validation: 'required|phone', label: 'Phone Number'
         },
         {
            type: 'select', class: 'col-12', model: 'role', filterable: true, clearable: true,
            multiple: false,options: [], validation: 'required', label: 'Role'
         },
      ]
   }
}

let tables = {
   users: {
      props: {
         icon: 'fa fa-user-tie',
         title: 'Users',
         border: true,
         'max-height': 500,
         'show-summary': false,
         search_fields: ["name", "phone_number.phone"],
         columns: [
            { type: 'selection', width: 60, align: 'center'},
            { type: 'index', width: 60, align: 'center'},
            { title: "Name", key: "names",width: 200},   
            { title: "Email", key: "email"},
            { title: "Phone Number", align: 'center', width: 180, render: (h, params) => {
               let phone = '+'

               if(params.row && params.row.phone_number && params.row.phone_number.phone){
                  phone += params.row.phone_number.phone
               }else{ 
                  phone = '-'
               }

               return h('b', phone);
            }},
            { 
               title: "Status", 
               key: "status", 
               width: 300,
               align: 'center',
               width: 180,
               render: (h, params) => {
                  return h(Status, {
                     props: {
                        status: params.row.status
                     }
                  });
               },
               filters: [
                  {
                     label: "Verified",
                     value: 1
                  },
                  {
                     label: "In-Active",
                     value: 2
                  }
               ],
               filterMultiple: false,
               filterMethod(value, row) {
                  switch(value){
                     case 1: return row.status === 'verified';
                     case 2: return row.status === 'inactive';
                  }
               }
            },
         ],
         actions: [
            { type: 'menu', title: 'Edit', event: 'user:edit', icon: 'fa-edit', allow_multiple: false },
            { type: 'menu', title: 'Delete', event: 'user:delete', icon: 'fa-trash-alt', allow_multiple: true },
         ]
      },
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}